import { render } from "./NewXMLFileDIfference.vue?vue&type=template&id=5e972233&scoped=true"
import script from "./NewXMLFileDIfference.vue?vue&type=script&lang=js"
export * from "./NewXMLFileDIfference.vue?vue&type=script&lang=js"

import "./NewXMLFileDIfference.vue?vue&type=style&index=0&id=5e972233&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e972233"]])

export default __exports__